import React, { useCallback } from 'react';
import ImportWithMappingDialog from '../../../components/common/ImportWithMappingDialog';
import { epcService } from '../../../services/epcService';
import type { ImportServiceAdapter, MappingColumnConfig } from '../../../types/import';

interface EPCImportDialogProps {
  open: boolean;
  onClose: () => void;
  onImportComplete: () => void;
}

const COLUMNS: MappingColumnConfig[] = [
  { key: 'tipo_de_risco', label: 'Tipo de Risco', valueType: 'string' },
];

const COLUMN_LABELS: Record<string, string> = {
  tipo_de_risco: 'Tipo de Risco',
};

const epcImportAdapter: ImportServiceAdapter = {
  previewImport: (file) => epcService.previewImport(file),
  executeImport: async (file, mappings) => {
    const result = await epcService.importEpcs(file, {
      mappings: mappings as Record<string, Record<string, string>> | undefined,
    });
    return {
      imported: result.imported,
      skipped: result.skipped,
      errors: result.errors,
    };
  },
  downloadTemplate: () => epcService.downloadTemplate(),
};

const EPCImportDialog: React.FC<EPCImportDialogProps> = ({
  open,
  onClose,
  onImportComplete,
}) => {
  const getImportOptions = useCallback(() => ({}), []);

  return (
    <ImportWithMappingDialog
      open={open}
      onClose={onClose}
      onImportComplete={onImportComplete}
      title="Importar EPCs"
      description="Selecione um arquivo Excel (.xlsx) com os EPCs para importar. Registros duplicados serão ignorados."
      entityLabel="EPC"
      templateFilename="template-importacao-epcs.xlsx"
      adapter={epcImportAdapter}
      columns={COLUMNS}
      columnLabels={COLUMN_LABELS}
      getImportOptions={getImportOptions}
    />
  );
};

export default EPCImportDialog;
